import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '../../../ThemeContext';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid, Button, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import AuthApi from '../../Services/Authapi';
import parse from 'html-react-parser';
import './Documents.css';
import swal from 'sweetalert';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ls from "local-storage";
import Switch from '@material-ui/core/Switch';
import AuthCheckComponent from '../../Layouts/Token';
import CloseIcon from "@material-ui/icons/Close";
import "./Documentslist.css"
import { createSwalLoaderNode } from '../../Layouts/swalLoader';

const EMAIL_TEMPLATE_CACHE_KEY = 'email-templates-cache';

const getCachedEmailTemplates = () => {
  try {
    const cachedValue = sessionStorage.getItem(EMAIL_TEMPLATE_CACHE_KEY);
    if (!cachedValue) return [];

    const parsedValue = JSON.parse(cachedValue);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (error) {
    console.error('Error reading cached email templates:', error);
    return [];
  }
};

const normalizeEmailTemplates = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

const EmailTemplates = (props) => {
  const classes = props;
  const [data, setdata] = useState(() => getCachedEmailTemplates());
  const [isLoading, setIsLoading] = useState(() => getCachedEmailTemplates().length === 0);
  const [hasFetched, setHasFetched] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const { darkMode } = useTheme();
  const retryTimeoutRef = useRef(null);

  useEffect(() => {
    if (props && props.authToken === false) {
      // props.history.push('/login');
    }
  });

  useEffect(() => {
    getallemailTemplates();

    return () => {
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, []);

  const getallemailTemplates = async (attempt = 0) => {
    let shouldRetry = false;
    const cachedTemplates = getCachedEmailTemplates();
    const hasExistingData = cachedTemplates.length > 0 || data.length > 0;

    if (!hasExistingData) {
      setIsLoading(true);
    }

    try {
      let role = await AuthApi.getallemailTemplates();

      if (role === false && attempt < 2) {
        shouldRetry = true;
        retryTimeoutRef.current = setTimeout(() => {
          getallemailTemplates(attempt + 1);
        }, 800);
        return;
      }

      const normalizedTemplates = normalizeEmailTemplates(role);
      setdata(normalizedTemplates);
      sessionStorage.setItem(EMAIL_TEMPLATE_CACHE_KEY, JSON.stringify(normalizedTemplates));
    } catch (error) {
      console.error('Error fetching data:', error);
      if (attempt < 2) {
        shouldRetry = true;
        retryTimeoutRef.current = setTimeout(() => {
          getallemailTemplates(attempt + 1);
        }, 800);
        return;
      }
      if (!hasExistingData) {
        setdata([]);
      }
    } finally {
      if (!shouldRetry) {
        setIsLoading(false);
        setHasFetched(true);
      }
    }
  };

  const addemailpage = () => {
    props.history.push('/add-email-template');
  };

  const toggleExpanded = (itemId) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [itemId]: !prevState[itemId],
    }));
  };

  const handleCheckboxChange = async (id, status) => {
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: createSwalLoaderNode()
    });
    try {
      let statu = await AuthApi.emailTemplatestatus(id, status);
      swal.close();
      if (statu && statu.status === true) {
        swal("Success", "Email Template status update successfully!", "success");
        getallemailTemplates();
      } else {
        swal("Error", statu, "error");
      }
    } catch (error) {
      swal.close();
      swal("Error", "An error occurred, Please try again later!", "error");
    }
  };

  const handleEdit = (id) => {
    props.history.push(`/edit-email-template/${id}`);
  };

  const handledelete = async (id) => {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (confirm) {
        let currentPermission = await AuthApi.emailTemplatedelete(id);
        if (currentPermission && currentPermission.status === true) {
          swal("Success", "Email Template deleted successfully!", "success");
          getallemailTemplates();
        } else {
        }
      }
    });
  }

  const User = ls("user");

  const userpermissions = (User && Array.isArray(User.roles) && User.roles[0] && Array.isArray(User.roles[0].permissions))
    ? User.roles[0].permissions.map(permissionObj => permissionObj.name)
    : [];

  const handleViewTemplate = (template) => {
    setSelectedTemplate(template);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const sanitizeTemplateHtml = (templateBody = "") => {
    if (typeof templateBody !== "string") {
      return "";
    }

    return templateBody
      .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, "")
      .replace(/<link\b[^>]*rel\s*=\s*(['"])stylesheet\1[^>]*>/gi, "")
      .replace(/\s(onmouse(?:over|enter|move|down|up|out|leave)|onfocus|onblur)\s*=\s*(['"]).*?\2/gi, "")
      .replace(/\sbgcolor\s*=\s*(['"]).*?\1/gi, "")
      .replace(/\sstyle\s*=\s*(['"])(.*?)\1/gi, (match, quote, styleValue) => {
        const filteredStyle = styleValue
          .split(";")
          .map((rule) => rule.trim())
          .filter(Boolean)
          .filter((rule) => {
            const property = rule.split(":")[0]?.trim().toLowerCase();
            return !["background", "background-color", "background-image"].includes(property);
          })
          .join("; ");

        return filteredStyle ? ` style=${quote}${filteredStyle}${quote}` : "";
      });
  };

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      {darkMode && (
        <style>{`
          .dark-dialog-paper {
            background-color: #2c2c2c !important;
            color: #ffffff !important;
          }
          .dark-dialog-content {
            background-color: #2c2c2c !important;
            color: #ffffff !important;
          }
          .dark-dialog-content * {
            background-color: transparent !important;
            border-color: #555 !important;
          }
        `}</style>
      )}
      <style>{`
        .email-template-preview {
          background-color: ${darkMode ? '#111111' : '#ffffff'} !important;
          color: ${darkMode ? '#ffffff' : '#111827'};
        }

        .email-template-preview,
        .email-template-preview * {
          background-image: none !important;
        }

        .email-template-preview,
        .email-template-preview *:hover,
        .email-template-preview *:focus,
        .email-template-preview *:active,
        .email-template-preview *::before,
        .email-template-preview *::after {
          background-color: transparent !important;
        }

        .email-template-preview > * {
          background-color: transparent !important;
        }

        .email-template-preview > * * {
          background-color: transparent !important;
        }

        .email-template-preview table,
        .email-template-preview tbody,
        .email-template-preview thead,
        .email-template-preview tfoot,
        .email-template-preview tr,
        .email-template-preview td,
        .email-template-preview th,
        .email-template-preview table:hover,
        .email-template-preview tbody:hover,
        .email-template-preview thead:hover,
        .email-template-preview tfoot:hover,
        .email-template-preview tr:hover,
        .email-template-preview td:hover,
        .email-template-preview th:hover {
          background-color: ${darkMode ? '#111111' : '#ffffff'} !important;
        }

        .email-template-preview,
        .email-template-preview p,
        .email-template-preview div,
        .email-template-preview span,
        .email-template-preview td,
        .email-template-preview th,
        .email-template-preview li,
        .email-template-preview a,
        .email-template-preview strong,
        .email-template-preview b {
          color: ${darkMode ? '#ffffff' : '#111827'} !important;
        }

        .email-template-preview h1,
        .email-template-preview h2,
        .email-template-preview h3,
        .email-template-preview h4,
        .email-template-preview h5,
        .email-template-preview h6 {
          color: ${darkMode ? '#ffffff' : '#0f172a'} !important;
        }
      `}</style>
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <div className="holiday-breadcrumb-card">
              <Breadcrumb
                {...props}
                primaryPageName="Email Templates"
                primaryPageLink="/email-templates"
                isSecondaryPage={false}
                secondaryPageName=""
              />
            </div>
            <Grid container className={classes.root} spacing={2} style={{ marginBottom: "75px" }}>
              <Grid item xs={12}>
                <Card className={`${classes.root} template-list-card`}>
                  <Grid item xs={12}>
                    <div className="template-list-header">
                      <CardContent className="template-list-header-content">
                        <Typography variant="h2" className="common-section-page-title" style={{ paddingTop: 0, paddingLeft: 0, paddingBottom: 0, marginBottom: "0" }}>All Email Templates</Typography>
                      </CardContent>
                      <div className="template-list-header-action">
                        <Button
                          variant="contained"
                          onClick={addemailpage}
                          color="primary"
                          className="common-action-button common-add-button"
                          style={{ textTransform: 'capitalize' }}
                        >
                          Add
                        </Button>
                      </div>
                    </div>
                  </Grid>
                  <Grid container className={`${classes.root} template-list-grid`} spacing={3}>
                    {isLoading ? (
                      <Grid item xs={12} style={{ padding: "24px", minHeight: "150px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "12px" }}>
                        <CircularProgress size={28} style={{ color: '#036dda' }} />
                        <Typography variant="body1" style={{ color: '#64748b', textAlign: 'center' }}>
                          Loading templates...
                        </Typography>
                      </Grid>
                    ) : Array.isArray(data) && data.length > 0 ? data.map((item) => (
                      <Grid item xs={12} sm={6} md={4} key={item.id} className="template-grid-item">
                        <Card className={`${classes.card} template-item-card`}>
                          <CardContent className="template-item-card-content">
                            <Typography variant="h5" component="div" className="template-item-title">
                              {item.template_name}
                            </Typography>

                            {item.template_body?.length > 0 && (
                              <div className="template-item-view">
                                <Button
                                  className="common-view-button"
                                  style={{
                                    cursor: "pointer",
                                    textTransform: 'capitalize'
                                  }}
                                  onClick={() => handleViewTemplate(item)}
                                >
                                  View
                                </Button>
                              </div>
                            )}

                            <Grid
                              container
                              className={`${classes.root} template-item-actions`}
                              spacing={0}
                              justifyContent="center"
                              alignItems="center"
                            >
                              {userpermissions.includes("Emailtemplates.Status") && (
                                <Grid item>
                                  <Tooltip title="Status">
                                    <Switch
                                      className="common-status-switch"
                                      checked={item.status === 1}
                                      onChange={() => handleCheckboxChange(item.id, item.status === 1 ? 0 : 1)}
                                      color="primary"
                                    />
                                  </Tooltip>
                                </Grid>
                              )}

                              {userpermissions.includes("Emailtemplates.Edit") && (
                                <Grid item>
                                  <Tooltip title="Email Template Edit">
                                    <IconButton
                                      variant="contained"
                                      color="primary"
                                      className="common-action-icon"
                                      onClick={() => handleEdit(item.id)}
                                    >
                                      <FontAwesomeIconComponent
                                        classes="fa fa-edit"
                                        colorName="primary"
                                        fontSize={"small"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              )}

                              {userpermissions.includes("Emailtemplates.Delete") && (
                                <Grid item>
                                  <Tooltip title="Delete">
                                    <IconButton
                                      variant="contained"
                                      color="primary"
                                      className="common-action-icon"
                                      onClick={() => handledelete(item.id)}
                                    >
                                      <FontAwesomeIconComponent
                                        classes="fa fa-trash"
                                        colorName="primary"
                                        fontSize={"small"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>

                        </Card>
                      </Grid>
                    )) : hasFetched ? (
                      <Grid item xs={12} style={{ padding: "12px", minHeight: "150px", display: "flex", justifyContent: "center", alignItems: "flex-start", marginTop: "40px" }}>
                        <Typography variant="body1" style={{ color: '#64748b', textAlign: 'center' }}>
                          No templates available
                        </Typography>
                      </Grid>
                    ) : null}
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </div>
        }
      />
      <Footer />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        disableScrollLock={true}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: '12px',
            boxShadow: '0 4px 20px rgba(3, 109, 218, 0.15)',
          },
          className: darkMode ? "dark-dialog-paper" : ""
        }}
      >
        <DialogTitle style={{ padding: '12px 24px' }}>
          {selectedTemplate?.template_name}
          <CloseIcon
            style={{
              position: "absolute",
              top: 12,
              right: 12,
              cursor: "pointer",
              color: "#ffffff",
            }}
            onClick={handleCloseDialog}
          />
        </DialogTitle>
        <DialogContent className={darkMode ? "dark-dialog-content template-preview-dialog-content" : "template-preview-dialog-content"} style={{ padding: '24px' }}>
          {selectedTemplate && (
            <div className="email-template-preview" style={{ border: '1px solid #e5eaf2', borderRadius: '8px', padding: '20px' }}>
              {parse(sanitizeTemplateHtml(selectedTemplate.template_body))}
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default EmailTemplates;
